import React from 'react'
import PropTypes from 'prop-types'

export const Context = React.createContext([])

const AppContext = (props) => {
    return (
        <Context.Consumer>
            {(parentContext) => {
                const context = Array.isArray(props.context) ? props.context : [props.context]
                return (
                    <Context.Provider value={[...parentContext, ...context]}>
                        {props.children}
                    </Context.Provider>
                )
            }}
        </Context.Consumer>
    )
}

/**
 * Util to render app context + div at once.
 */
AppContext.div = ({ context, children, ...props }) => {
    return (
        <AppContext context={context}>
            <div {...props}>
                {children}
            </div>
        </AppContext>
    )
}

AppContext.propTypes = {
    context: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
    children: PropTypes.any,
}

export default AppContext
